var map = {
	"./layout.two-columns-2-1.html": 624,
	"./layout.two-equal-cols.html": 625,
	"./page.basic.html": 626,
	"./page.frontpage-parallax-full.html": 627
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;



//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets ^\.\/.*\.html$
// module id = 623
// module chunks = 0